/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (!boostSDAppConfig?.searchSettings?.highlightSuggestionResult) {
    boostSDAppConfig.searchSettings.highlightSuggestionResult = true;
}
function buidSwatchHtml(data) {
    var html = '';
    var newArray = [];
    var newArrayImage = [];
    html += '<div class = "custom-swatch"> ';
    data.variants.forEach(function(variant) {
        var value = (variant.title.split(' / ')[2] + '-' + variant.title.split(' / ')[0]).replace(' ', '-');
        var newValue = variant.original_merged_options 
          ?
          variant.original_merged_options.reduce((res,cur) => {
            if (cur.indexOf('color:') === 0) {
              res = res.length > 0 ? res + '-' + cur.split('olor:')[1].toLowerCase().replace(/ /g,'-').toLowerCase().replace(/\//g,'-') : cur.split('olor:')[1].toLowerCase().replace(/ /g,'-').toLowerCase().replace(/\//g,'-');
            }
            if (cur.indexOf('fabric:') === 0) {
              res = res.length > 0 ? cur.split('abric:')[1].toLowerCase().replace(/ /g,'-').toLowerCase().replace(/\//g,'-') + '-' + res : cur.split('abric:')[1].toLowerCase().replace(/ /g,'-').toLowerCase().replace(/\//g,'-');
            }
            return res;
          },'')
          : 
          variant.merged_options.reduce((res,cur) => {
            if (cur.indexOf('color:') === 0) {
              res = res.length > 0 ? res + '-' + cur.split('olor:')[1].toLowerCase().replace(/ /g,'-').toLowerCase().replace(/\//g,'-') : cur.split('olor:')[1].toLowerCase().replace(/ /g,'-').toLowerCase().replace(/\//g,'-');
            }
            if (cur.indexOf('fabric:') === 0) {
              res = res.length > 0 ? cur.split('abric:')[1].toLowerCase().replace(/ /g,'-').toLowerCase().replace(/\//g,'-') + '-' + res : cur.split('abric:')[1].toLowerCase().replace(/ /g,'-').toLowerCase().replace(/\//g,'-');
            }
            return res;
          },'');
        var url_color = newValue.length > 0 ? _getFilePath(_slugify(newValue.toLowerCase()), 'png', 1) : _getFilePath(_slugify(value.toLowerCase()), 'png', 1);
        if (newArray.indexOf(url_color) === -1) {
            newArray.push(url_color)
            newArrayImage.push(variant.image);
        }
    });
    for (var i = 0; i <= newArray.length; i++) {
        var backgroundColor = newArray[i];
        if (newArray.length === 1 || backgroundColor === undefined || backgroundColor.indexOf(undefined) > -1) {
            html += '';
        } else {
            html += ' <span data-image="' + newArrayImage[i] + '" class="swatch-item" style="background-image: url(' + backgroundColor + ')"></span>';

        }
    }
    html += ' </div>';
    
    return html;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('SearchProductItem', {
            name: 'Customize product items in ISW',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        let productData = element.getParams().props.product;
                        let productId = productData.id;
                        if (productData?.split_product) {
                           productId = productData.variant_id;
                        }
                        let productItem = document.querySelector('.boost-sd__suggestion-queries-item[data-id="' + productId + '"]');

                        if (productItem && !productItem.querySelector('.custom-swatch')) {
                            const swatchHtml = buidSwatchHtml(productData);
                            productItem.querySelector('.boost-sd__suggestion-queries-item-product--right').insertAdjacentHTML('beforeend', swatchHtml);
                        }
                    } catch(error) {
                        console.warn(error);
                    }
                }
            }),
        });
    }
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Customize product items in PLP',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        let productData = element.getParams().props.product;
                        let productId = productData.id;
                        if (productData?.split_product) {
                           productId = productData.variant_id;
                        }
                        let productItem = document.querySelector('.boost-sd__product-item[data-product-id="' + productId + '"]');
                          console.log("running on plp", productItem, productData)
                        if (productItem && !productItem.querySelector('.custom-swatch')) {
                            const swatchHtml = buidSwatchHtml(productData);
                            productItem.querySelector('.boost-sd__product-swatch').innerHTML = swatchHtml
                        }
                    } catch(error) {
                        console.warn(error);
                    }
                }
            }),
        });
    }
]);

function _slugify(text) {
	if (text == null || typeof text == 'object') return '';
	if (typeof text != 'string') {
		if (typeof text.toString != 'function') {
			return '';
		} else {
			text = text.toString();
		}
	}
	text = text.toLowerCase();

	// Remove Latin
	var from = "àáäâãèéëêẽìíïîĩòóöôõùúüûũñç·/_,:;";
	var to = "aaaaaeeeeeiiiiiooooouuuuunc--_---";
	for (var i = 0, l = from.length; i < l; i++)
		text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));

	// Remove Czech, Finnish special characters
	var specialCzechChars = 'ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž';
	var asciiCzechChars = 'AaAaCcDdEeeIiNnOoOoRrSsTtUuuYyZz';
	var specialCzechCharsLength = specialCzechChars.length;
	for (var j = 0; j < specialCzechCharsLength; j++) {
		text = text.replace(new RegExp(specialCzechChars.charAt(j), "g"), asciiCzechChars.charAt(j));
	}

	// Remove Norway special characters
	var specialNorwayChars = 'ÆæØøÅå';
	var asciiNorwayChars = ['AE', 'ae', 'O', 'o', 'A', 'a'];
	var specialNorwayCharsLength = specialNorwayChars.length;
	for (var k = 0; k < specialNorwayCharsLength; k++) {
		text = text.replace(new RegExp(specialNorwayChars.charAt(k), "g"), asciiNorwayChars[k]);
	}

	// Remove quotes
	text = text.replace(/'/g, '').replace(/"/g, '');

	return text.replace(/[\s\/]+/g, '-')    // Replace spaces with -
		.replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-')   // Replace all special characters with -
		.replace(/\-\-+/g, '-')     // Replace multiple - with single -
		.replace(/^-+/, '')         // Trim - from start of text
		.replace(/-+$/, '');         // Trim - from end of text
};

function _getFilePath(fileName, extension, version) {
	var extension = typeof extension !== 'undefined' ? extension : 'png';
	var version = typeof version !== 'undefined' ? version : '';
	var filePath = boostSDAppConfig.generalSettings.file_url.split('?')[0];
	filePath += fileName + '.' + extension + (version ? ('?v=' + version) : '');
	return filePath;
}